import { useToast } from '@astryxdesign/core/Toast';
import { usePage } from '@inertiajs/react';
import { useEffect } from 'react';

interface FlashProps {
  notice?: string;
  error?: string;
  alert?: string;
}

const Flash = ({ notice, error, alert }: FlashProps) => {
  const toast = useToast();
  const { flash } = usePage().props as unknown as { flash: FlashProps };

  useEffect(() => {
    const newNotice = notice || flash?.notice;
    const newError = error || flash?.error || flash?.alert;

    if (newNotice) {
      toast({ body: newNotice, type: 'info', uniqueID: 'flash-notice' });
    } else if (newError) {
      toast({ body: newError, type: 'error', uniqueID: 'flash-error' });
    }
  }, [notice, error, alert, flash, toast]);

  return null;
};

export default Flash;
